var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { Image } from '../Image';
import media from '../../utils/media';
const Container = styled.div `
  text-align: center;
  top: 0px;
`;
const ImageContainer = styled.div `
  overflow: hidden;
`;
const ImageContent = styled((_a) => {
    var { isMobile } = _a, others = __rest(_a, ["isMobile"]);
    return React.createElement(Image, Object.assign({}, others));
}) `
  -webkit-user-drag: none;
  max-width: 962px;
  height: 468px;
  display: block;

  ${media.mobile} {
    height: 359px;
  }
  ${media.mobileL} {
    height: 250px;
  }
  @media (min-width: 1084px) {
    width: 962px;
    height: 468px;
  }
  @media (min-width: 1250px) {
    width: 1110px;
    height: 540px;
    max-width: 1110px;
  }
`;
export const CarouselSlide = ({ image }) => {
    return (React.createElement(Container, null,
        React.createElement(ImageContainer, null,
            React.createElement(ImageContent, { media: image }))));
};
